import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  DangerSemantic_getInstance1xd9zwrvs99lp as DangerSemantic_getInstance,
  WarningSemantic_getInstance3kp0xfef7wnw4 as WarningSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  AffirmativeSemantic_getInstance2svzxainpava5 as AffirmativeSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance3rf6ssn2f6rf5 as Companion_getInstance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DateTimeUnit.mjs';
import {
  minusrtzvftl23j9y as minus,
  plus31cnlckpy77fa as plus,
  YearMonth22nahmknr467s as YearMonth,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/YearMonth.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { BalanceSheetPage2218um6yj4e9j as BalanceSheetPage } from '../reports/BalanceSheetPage.mjs';
import { singleo93pzdgfc557 as single } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { RemittanceDetailPage384df89l74tfl as RemittanceDetailPage } from '../remittances/RemittanceDetailPage.mjs';
import { RemittanceReviewPage1y592xgwqobqi as RemittanceReviewPage } from '../remittances/RemittanceReviewPage.mjs';
import { AttendancePeriodsListPagekcmctzhabmp9 as AttendancePeriodsListPage } from '../attendance/AttendancePeriodsListPage.mjs';
import {
  ID1m87d1hextx54 as ID,
  LocationAttendancePeriod3bx3r7kkwecs9 as LocationAttendancePeriod,
  CareProvider2qcawrqluyllr as CareProvider,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { setOf1u3mizs95ngxo as setOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { AttendancePeriodFilters2ya4mm5gzi7ou as AttendancePeriodFilters } from '../attendance/AttendancePeriodFilters.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { ChipSemantic_getInstancen74y1gyt9zmo as ChipSemantic_getInstance } from '../../theme/semantics.mjs';
import {
  dynamicThemed3lsusnjffkq9e as dynamicThemed,
  themed2vu67ornd4jps as themed,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
  Link$_get_to_$ref_jq7esp1qhuglz6kwpan as Link$_get_to_$ref_jq7esp,
  Link$_set_to_$ref_i9gu5xmkiv49juwaf as Link$_set_to_$ref_i9gu5x,
} from '../../App.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { today1rno4frfjp5oe as today } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import { DatePeriod2y4m7pf19ebgd as DatePeriod } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DateTimePeriod.mjs';
import { minushnjyym3nfk5o as minus_0 } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { get_range1w8h4wo8ecr88 as get_range } from '../remittances/remittanceComponents.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_periodnytt0bk9l5et as get_period,
  get_forDatesipvp1vaghli1 as get_forDates,
  get_voided2jr696tzb1zxm as get_voided,
  get__id1301miildb0kq as get__id,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { overlapsia57gal7znoc as overlaps } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/dateRangeConditions.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { CareProviderRemittances9omflxtwvni as CareProviderRemittance } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/money.mjs';
import {
  eq353yrgcpovoi1 as eq,
  inside26mvda7ucvpq5 as inside,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { and3dbt2f202um49 as and } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  get_scrolling3fwkltztkpfe8 as get_scrolling,
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  maxWidth22r11xnm7d4h4 as maxWidth,
  iconButton2nzpucy7a6ixd as iconButton,
} from '../components/view-utilities.mjs';
import {
  get_atBottomStart1iulwjfo1udg3 as get_atBottomStart,
  get_centered31th09q7x90sf as get_centered,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  Companion_getInstance23x6zslwzj0st as Companion_getInstance_1,
  Align_Center_getInstance366ihr7rj12mu as Align_Center_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { renderToString1pjqj7ffu15sz as renderToString } from '../../utils/daterender.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { text189ciz0cnr32o as text } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { ReportFiltersigb451dg4asm as ReportFilters } from '../reports/ReportFilters.mjs';
import {
  DayTotalsPage3tkd9ei9dl3us as DayTotalsPage,
  DayGrouping_Provider_getInstance3entcec0uiq20 as DayGrouping_Provider_getInstance,
} from '../reports/DayTotalsPage.mjs';
import { SingleDaysPage2w42wjhncrkcq as SingleDaysPage } from '../reports/SingleDaysPage.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_0,
  table1wgqnzrzsmc0y as table,
} from '../components/table.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  CloseOutStatus_AttendanceIncomplete_instance = new (CloseOutStatus())('AttendanceIncomplete', 0, CloseOutPage$CloseOutStatus$lambda, DangerSemantic_getInstance());
  CloseOutStatus_AttendanceReviewNeeded_instance = new (CloseOutStatus())('AttendanceReviewNeeded', 1, CloseOutPage$CloseOutStatus$lambda_0, WarningSemantic_getInstance());
  CloseOutStatus_ReadyForRemittance_instance = new (CloseOutStatus())('ReadyForRemittance', 2, CloseOutPage$CloseOutStatus$lambda_1, ImportantSemantic_getInstance());
  CloseOutStatus_Complete_instance = new (CloseOutStatus())('Complete', 3, CloseOutPage$CloseOutStatus$lambda_2, AffirmativeSemantic_getInstance());
}
var CloseOutStatus_AttendanceIncomplete_instance;
var CloseOutStatus_AttendanceReviewNeeded_instance;
var CloseOutStatus_ReadyForRemittance_instance;
var CloseOutStatus_Complete_instance;
function CloseOutPage$CloseOutStatus$lambda(_this__u8e3s4) {
  return _this__u8e3s4.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_closeOutAttendanceIncomplete_qvityy_k$();
}
function CloseOutPage$CloseOutStatus$lambda_0(_this__u8e3s4) {
  return _this__u8e3s4.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_closeOutAttendanceReviewNeeded_5v2tud_k$();
}
function CloseOutPage$CloseOutStatus$lambda_1(_this__u8e3s4) {
  return _this__u8e3s4.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_closeOutReadyForRemittance_zhgfk3_k$();
}
function CloseOutPage$CloseOutStatus$lambda_2(_this__u8e3s4) {
  return _this__u8e3s4.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_closeOutComplete_hpmhjs_k$();
}
var CloseOutStatusClass;
function CloseOutStatus() {
  if (CloseOutStatusClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, label, semantic) {
        super(name, ordinal);
        this.label_1 = label;
        this.semantic_1 = semantic;
      }
    }
    initMetadataForClass($, 'CloseOutStatus');
    CloseOutStatusClass = $;
  }
  return CloseOutStatusClass;
}
var ProviderForRangeClass;
function ProviderForRange() {
  if (ProviderForRangeClass === VOID) {
    class $ {
      constructor(month, provider, remittance, status) {
        this.month_1 = month;
        this.provider_1 = provider;
        this.remittance_1 = remittance;
        this.status_1 = status;
      }
      toString() {
        return 'ProviderForRange(month=' + this.month_1.toString() + ', provider=' + this.provider_1.toString() + ', remittance=' + toString(this.remittance_1) + ', status=' + this.status_1.toString() + ')';
      }
      hashCode() {
        var result = this.month_1.hashCode();
        result = imul(result, 31) + this.provider_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.remittance_1) | 0;
        result = imul(result, 31) + this.status_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ProviderForRange()))
          return false;
        if (!this.month_1.equals(other.month_1))
          return false;
        if (!this.provider_1.equals(other.provider_1))
          return false;
        if (!equals(this.remittance_1, other.remittance_1))
          return false;
        if (!this.status_1.equals(other.status_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ProviderForRange');
    ProviderForRangeClass = $;
  }
  return ProviderForRangeClass;
}
function CloseOutPage$_get_title_$lambda_l5pcj3($this$remember) {
  return $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_closeOutPageTitle_igqf2i_k$();
}
function CloseOutPage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_closeOutPageTitle_igqf2i_k$();
}
function CloseOutPage$render$lambda_0($this$iconButton) {
  return $this$iconButton.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittancesPreviousMonthDescription_c46s75_k$();
}
function CloseOutPage$render$lambda$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    this$0.month_1.set_value_v1vabv_k$(minus(this$0.month_1.get_value_j01efc_k$(), 1, Companion_getInstance().MONTH_1));
    return Unit_instance;
  }), 0);
}
function CloseOutPage$render$lambda_1($this$iconButton) {
  return $this$iconButton.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittancesNextMonthDescription_472mkb_k$();
}
function CloseOutPage$render$lambda$slambda_0(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    this$0.month_1.set_value_v1vabv_k$(plus(this$0.month_1.get_value_j01efc_k$(), 1, Companion_getInstance().MONTH_1));
    return Unit_instance;
  }), 0);
}
function CloseOutPage$render$lambda_2($this$invoke) {
  return CloseOutPage$render$lambda$lambda;
}
function CloseOutPage$render$lambda$lambda() {
  return new (BalanceSheetPage())();
}
function CloseOutPage$render$lambda_3(it) {
  var tmp;
  switch (it.status_1.ordinal_1) {
    case 3:
      tmp = new (RemittanceDetailPage())(single(it.remittance_1)._id_1);
      break;
    case 2:
      tmp = new (RemittanceReviewPage())(it.provider_1._id_1, it.month_1.get_firstDay_u4rr11_k$());
      break;
    case 1:
    case 0:
      // Inline function 'kotlin.apply' call

      var this_0 = new (AttendancePeriodsListPage())();
      this_0.filter_1.set_value_v1vabv_k$(new (AttendancePeriodFilters())(it.month_1.get_firstDay_u4rr11_k$(), it.month_1.get_lastDay_hikhp_k$(), VOID, VOID, VOID, setOf(new (ID())(it.provider_1._id_1))));
      tmp = this_0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function CloseOutPage$render$lambda_4($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittancesProviderColumn_b68mq5_k$();
}
function CloseOutPage$render$lambda_5($this$text, it) {
  return it.provider_1.name_1;
}
function CloseOutPage$render$lambda_6($this$custom) {
  return $this$custom.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittancesStatusColumn_9ruzm4_k$();
}
function CloseOutPage$render$lambda_7($this$custom, datum) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())($this$custom.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$custom.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_0 = dynamicThemed(element, ($this$dynamicThemed) => ChipSemantic_getInstance().plus_duvq05_k$($this$dynamicThemed.invoke_r7m7el_k$(datum).status_1.semantic_1));
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (TextView())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
  element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(datum).status_1.label_1($this$invoke));
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  $this$custom.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function CloseOutPage$render$lambda_8($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
function CloseOutStatus_AttendanceIncomplete_getInstance() {
  static_init();
  return CloseOutStatus_AttendanceIncomplete_instance;
}
function CloseOutStatus_AttendanceReviewNeeded_getInstance() {
  static_init();
  return CloseOutStatus_AttendanceReviewNeeded_instance;
}
function CloseOutStatus_ReadyForRemittance_getInstance() {
  static_init();
  return CloseOutStatus_ReadyForRemittance_instance;
}
function CloseOutStatus_Complete_getInstance() {
  static_init();
  return CloseOutStatus_Complete_instance;
}
var CloseOutPageClass;
function CloseOutPage() {
  if (CloseOutPageClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.let' call
        var it = minus_0(today(), DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(VOID, 1));
        var tmp$ret$0 = YearMonth().new_kotlinx_datetime_YearMonth_rn1bif_k$(it.year_1, it.get_month_ivc8d3_k$());
        tmp.month_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(tmp$ret$0);
        var tmp_0 = this;
        tmp_0.data_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var session = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull());
          var range = get_range($this$remember.invoke_r7m7el_k$(this.month_1));
          var tmp = session.get_locationAttendancePeriods_kbvlcb_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(LocationAttendancePeriod()), arrayOf([]), false));
          var tmp$ret$4 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$4);
          var tmp$ret$2 = overlaps(get_period(it), range);
          var periods = $this$remember.invoke_r7m7el_k$(tmp.list$default_sjz00l_k$(new (Query())(tmp$ret$2, VOID, VOID, 10000)));
          var tmp_1 = session.get_careProviderRemittances_dyezti_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(CareProviderRemittance()), arrayOf([]), false));
          var tmp$ret$9 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_0 = new (DataClassPathSelf())(tmp$ret$9);
          var tmp$ret$7 = and(overlaps(get_forDates(it_0), range), eq(get_voided(it_0), null));
          var remittances = $this$remember.invoke_r7m7el_k$(tmp_1.list$default_sjz00l_k$(new (Query())(tmp$ret$7, VOID, VOID, 10000)));
          var tmp_3 = session.get_careProviders_b5tc2w_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_4 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
          var tmp$ret$14 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_1 = new (DataClassPathSelf())(tmp$ret$14);
          var tmp_5 = get__id(it_1);
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(periods, 10));
          var _iterator__ex2g4s = periods.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s.next_20eer_k$();
            var tmp$ret$19 = new (ID())(item.provider_1);
            destination.add_utx5q5_k$(tmp$ret$19);
          }
          var tmp$ret$12 = inside(tmp_5, destination);
          var providers = $this$remember.invoke_r7m7el_k$(tmp_3.list$default_sjz00l_k$(new (Query())(tmp$ret$12)));
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(providers, 10));
          var _iterator__ex2g4s_0 = providers.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var item_0 = _iterator__ex2g4s_0.next_20eer_k$();
            // Inline function 'kotlin.collections.filter' call
            // Inline function 'kotlin.collections.filterTo' call
            var destination_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
            var _iterator__ex2g4s_1 = periods.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s_1.next_20eer_k$();
              if (equals(element.provider_1, item_0._id_1)) {
                destination_1.add_utx5q5_k$(element);
              }
            }
            var providerPeriods = destination_1;
            // Inline function 'kotlin.collections.filter' call
            // Inline function 'kotlin.collections.filterTo' call
            var destination_2 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
            var _iterator__ex2g4s_2 = remittances.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
              var element_0 = _iterator__ex2g4s_2.next_20eer_k$();
              if (equals(element_0.provider_1, item_0._id_1)) {
                destination_2.add_utx5q5_k$(element_0);
              }
            }
            var providerRemittances = destination_2;
            var tmp_6 = $this$remember.invoke_r7m7el_k$(this.month_1);
            var tmp_7;
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!providerRemittances.isEmpty_y1axqb_k$()) {
              tmp_7 = CloseOutStatus_Complete_getInstance();
            } else {
              var tmp$ret$30;
              $l$block_0: {
                // Inline function 'kotlin.collections.all' call
                var tmp_8;
                if (isInterface(providerPeriods, Collection())) {
                  tmp_8 = providerPeriods.isEmpty_y1axqb_k$();
                } else {
                  tmp_8 = false;
                }
                if (tmp_8) {
                  tmp$ret$30 = true;
                  break $l$block_0;
                }
                var _iterator__ex2g4s_3 = providerPeriods.iterator_jk1svi_k$();
                while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
                  var element_1 = _iterator__ex2g4s_3.next_20eer_k$();
                  if (!!(element_1.approved_1 == null)) {
                    tmp$ret$30 = false;
                    break $l$block_0;
                  }
                }
                tmp$ret$30 = true;
              }
              if (tmp$ret$30) {
                tmp_7 = CloseOutStatus_ReadyForRemittance_getInstance();
              } else {
                var tmp$ret$32;
                $l$block_2: {
                  // Inline function 'kotlin.collections.all' call
                  var tmp_9;
                  if (isInterface(providerPeriods, Collection())) {
                    tmp_9 = providerPeriods.isEmpty_y1axqb_k$();
                  } else {
                    tmp_9 = false;
                  }
                  if (tmp_9) {
                    tmp$ret$32 = true;
                    break $l$block_2;
                  }
                  var _iterator__ex2g4s_4 = providerPeriods.iterator_jk1svi_k$();
                  while (_iterator__ex2g4s_4.hasNext_bitz1p_k$()) {
                    var element_2 = _iterator__ex2g4s_4.next_20eer_k$();
                    if (!!(element_2.submitted_1 == null)) {
                      tmp$ret$32 = false;
                      break $l$block_2;
                    }
                  }
                  tmp$ret$32 = true;
                }
                if (tmp$ret$32) {
                  tmp_7 = CloseOutStatus_AttendanceReviewNeeded_getInstance();
                } else {
                  tmp_7 = CloseOutStatus_AttendanceIncomplete_getInstance();
                }
              }
            }
            var tmp$ret$22 = new (ProviderForRange())(tmp_6, item_0, providerRemittances, tmp_7);
            destination_0.add_utx5q5_k$(tmp$ret$22);
          }
          return destination_0;
        });
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, CloseOutPage$_get_title_$lambda_l5pcj3);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance_0().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_atBottomStart(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = weight(this_2, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, CloseOutPage$render$lambda);
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        var tmp_2 = get_centered(element_0);
        var tmp_3 = Companion_getInstance_1().chevronLeft_1;
        var tmp_4 = CloseOutPage$render$lambda_0;
        iconButton(tmp_2, tmp_3, tmp_4, ($this$iconButton) => {
          onClick($this$iconButton, VOID, VOID, VOID, CloseOutPage$render$lambda$slambda(this));
          return Unit_instance;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_4 = sizeConstraints(get_centered(element_0), VOID, VOID, VOID, VOID, VOID, get_rem(5));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (TextView())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_4.willAddChild_hz2iwc_k$(element_2);
        element_2.set_align_ypalx0_k$(Align_Center_getInstance());
        var tmp_5 = KMutableProperty0();
        var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_2);
        var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_2));
        element_2.invoke_bnq13k_k$(tmp_7, ($this$invoke) => renderToString($this$invoke.invoke_r7m7el_k$(this.month_1)));
        element_2.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_2);
        var tmp_8 = get_centered(element_0);
        var tmp_9 = Companion_getInstance_1().chevronRight_1;
        var tmp_10 = CloseOutPage$render$lambda_1;
        iconButton(tmp_8, tmp_9, tmp_10, ($this$iconButton) => {
          onClick($this$iconButton, VOID, VOID, VOID, CloseOutPage$render$lambda$slambda_0(this));
          return Unit_instance;
        });
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        element.willAddChild_hz2iwc_k$(element_3);
        element_3.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_5 = themed(element_3, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (Link())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_5.willAddChild_hz2iwc_k$(element_4);
        text(element_4, 'Totals by provider');
        var tmp_11 = KMutableProperty0();
        var tmp_12 = Link$_get_to_$ref_jq7esp(element_4);
        var tmp_13 = getPropertyCallableRef('to', 0, tmp_11, tmp_12, Link$_set_to_$ref_i9gu5x(element_4));
        element_4.invoke_bnq13k_k$(tmp_13, ($this$invoke) => {
          // Inline function 'kotlin.let' call
          var f = new (ReportFilters())($this$invoke.invoke_r7m7el_k$(this.month_1).get_firstDay_u4rr11_k$(), $this$invoke.invoke_r7m7el_k$(this.month_1).get_lastDay_hikhp_k$());
          return () => {
            // Inline function 'kotlin.apply' call
            var this_0 = new (DayTotalsPage())();
            this_0.filter_1.set_value_v1vabv_k$(f);
            this_0.groupBy_1.set_value_v1vabv_k$(DayGrouping_Provider_getInstance());
            return this_0;
          };
        });
        element_4.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_6 = themed(element_3, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (Link())(this_6.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_6.willAddChild_hz2iwc_k$(element_5);
        text(element_5, 'Billed days');
        var tmp_14 = KMutableProperty0();
        var tmp_15 = Link$_get_to_$ref_jq7esp(element_5);
        var tmp_16 = getPropertyCallableRef('to', 0, tmp_14, tmp_15, Link$_set_to_$ref_i9gu5x(element_5));
        element_5.invoke_bnq13k_k$(tmp_16, ($this$invoke) => {
          // Inline function 'kotlin.let' call
          var f = new (ReportFilters())($this$invoke.invoke_r7m7el_k$(this.month_1).get_firstDay_u4rr11_k$(), $this$invoke.invoke_r7m7el_k$(this.month_1).get_lastDay_hikhp_k$());
          return () => {
            // Inline function 'kotlin.apply' call
            var this_0 = new (SingleDaysPage())();
            this_0.filter_1.set_value_v1vabv_k$(f);
            return this_0;
          };
        });
        element_5.onStartup_vrxh3i_k$();
        this_6.addChild_2qpft2_k$(element_5);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_7 = themed(element_3, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (Link())(this_7.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        this_7.willAddChild_hz2iwc_k$(element_6);
        text(element_6, 'Balance sheet');
        var tmp_17 = KMutableProperty0();
        var tmp_18 = Link$_get_to_$ref_jq7esp(element_6);
        var tmp_19 = getPropertyCallableRef('to', 0, tmp_17, tmp_18, Link$_set_to_$ref_i9gu5x(element_6));
        element_6.invoke_bnq13k_k$(tmp_19, CloseOutPage$render$lambda_2);
        element_6.onStartup_vrxh3i_k$();
        this_7.addChild_2qpft2_k$(element_6);
        element_3.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_3);
        var tmp_20 = CloseOutPage$render$lambda_3;
        var tmp_21 = Companion_instance_0;
        var tmp_22 = CloseOutPage$render$lambda_4;
        var tmp_23 = tmp_21.text$default_gwb2zv_k$(tmp_22, VOID, CloseOutPage$render$lambda_5);
        var tmp_24 = Companion_instance_0;
        var tmp_25 = CloseOutPage$render$lambda_6;
        table(element, this.data_1, tmp_20, [tmp_23, tmp_24.custom$default_tn6l2s_k$(tmp_25, VOID, CloseOutPage$render$lambda_7)]);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_8 = shownWhen(element, VOID, VOID, CloseOutPage$render$lambda_8);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (Space())(this_8.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_7);
        this_8.willAddChild_hz2iwc_k$(element_7);
        element_7.onStartup_vrxh3i_k$();
        this_8.addChild_2qpft2_k$(element_7);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'CloseOutPage', CloseOutPage, VOID, [Page()]);
    CloseOutPageClass = $;
  }
  return CloseOutPageClass;
}
//region block: exports
export {
  CloseOutPage as CloseOutPagesekceysksiq3,
};
//endregion

//# sourceMappingURL=CloseOutPage.mjs.map
